import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/react/icon";
export default createIcon({
    displayName: "TrustPilot",
    viewBox: "0 0 24 24",
    path: (_jsxs(_Fragment, { children: [_jsx("path", { d: "M20 7.64341H12.3627L10.0037 0L7.6373 7.64341L0 7.63566L6.18504 12.3643L3.81865 20L10.0037 15.2791L16.1814 20L13.8223 12.3643L20 7.64341Z", fill: "#00B67A" }), _jsx("path", { d: "M14.3531 14.093L13.8223 12.3643L10.0037 15.2791L14.3531 14.093Z", fill: "#005128" })] })),
});
